import pluralize from 'pluralize'
import React, { useState } from 'react'

import { normalize, stringifyDate, usePet } from '../../modules'

import Modal from "../reusable/modal"
import Receive from '../reusable/receive'

const ByPaymentMethod = ({ toggle, visible, ranges, onOK }) => {
    const [methods, setMethods] = useState([])

    const [{ loading, error }, earnings] = usePet('earnings',
        ranges ? 
            { 
                from: ranges[0]?._d ?? null, 
                to: ranges[1]?._d ?? null 
            }
        : {}
    , { notify: true, callback: ({ data }) => setMethods(data) })
    
    return (
        <Modal
            w={ 800 }
            centered={ false }
            title="Earnings By Payment Method"
            toggle={toggle}
            visible={visible}>
            <Receive
                error={error}
                loading={loading}
                progress>
                <>
                    <p className="text-lg font-bold">Sales { String(ranges[0]) === String(ranges[1]) ? `For ${stringifyDate(ranges[0]?._d, true)}` : `From ${stringifyDate(ranges[0]?._d, true)} To ${stringifyDate(ranges[1]?._d, true)}` }</p>
                    <div className="grid grid-cols-12 gap-6 mb-5">
                        <div className="flex flex-col p-4 rounded-sm col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-gray-200">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-800 mb-2">Total</h2>
                                <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Total Sales</div>
                                <div className="flex items-start">
                                <div className="text-2xl font-bold text-gray-800 mr-2">Ksh. { normalize(methods.reduce((total, mth) => total + mth.total, 0)) }</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="text-lg font-bold">Sales By Payment Method</p>
                    <div className="grid grid-cols-12 gap-6 mb-5">
                        {
                            methods.map(method =>
                                <div className="flex flex-col p-4 col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-gray-200">
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-800 mb-2">{ method._id }</h2>
                                        <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Sales</div>
                                        <div className="flex items-start">
                                        <div className="text-2xl font-bold text-gray-800 mr-2">Ksh. { normalize(method.total) }</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </>
            </Receive>
            <div className="flex justify-end">
                <button type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print</button>
            </div>
        </Modal>
    )
}

export default ByPaymentMethod